import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MdIconComponent } from '@inditex/mduikit';
import { TranslateModule } from '@ngx-translate/core';

import { HeaderSectionsComponent } from './components/header-sections/header-sections.component';
import { HeaderContainerComponent } from './layouts/header-container/header-container.component';
import { HeaderTopbarComponent } from './layouts/header-topbar/header-topbar.component';

import { OffsetBodyDirective } from '@layout/ui/directives/offset-body.directive';
import { ElementObserverDirective } from '@shared/directives/element-observer.directive';
import { HeaderSearchComponent } from '@shared/header/components/header-search/header-search.component';
import {
    HeaderTopbarSm2024Component,
} from '@shared/header/layouts/header-topbar-sm-2024/header-topbar-sm-2024.component';
import { HeaderService } from '@shared/header/services/header.service';
import { HeaderMenuModule } from '@shared/header-menu/header-menu.module';
import { MenuCategoriesModule } from '@shared/menu-categories/menu-categories.module';
import { TopNotificationComponent } from '@shared/top-notification/top-notification.component';
import { MdLogoComponent } from '@ui/md-logo/md-logo.component';

@NgModule({
    declarations: [
        HeaderContainerComponent,
        HeaderSectionsComponent,
        HeaderTopbarComponent,
    ],
    imports: [
        CommonModule,
        ElementObserverDirective,
        HeaderMenuModule,
        HeaderSearchComponent,
        HeaderTopbarSm2024Component,
        MdIconComponent,
        MdLogoComponent,
        MenuCategoriesModule,
        OffsetBodyDirective,
        TopNotificationComponent,
        TranslateModule.forChild(),
    ],
    exports: [
        HeaderContainerComponent,
    ],
    providers: [
        HeaderService,
    ],
})
export class HeaderModule { }
